export const CONSENTS_MAPPING = {
  isAgreedTheFees: {
    name: 'Fees and Cancellation Policy',
    description: 'I have read and accepted the service fee terms and conditions of the Amplar Health Virtual Psychology Clinic; I understand the Amplar Health Virtual Psychology team will collect my card details for payment via eway, a secure payment gateway. I agree to pay the full fee 72 hours prior to our consultation. I consent Amplar Health Virtual Psychology team to use my collected card details for payment of any follow-up consults I book and attend.',
  },
  isAgreedTheCancelPolicy: {
    name: 'Fees and Cancellation Policy',
    description: 'Our psychologists have reserved time for you. If you must cancel your consultation, we respectfully request 48 hours&apos; notice. Missed consultations, or consultations cancelled without a valid medical reason within 48 hours of the consultations, will incur a fee equivalent to the full fee of such consultation',
  },
  isAgreedThePrivacyPolicy: {
    name: 'Consents',
    description: 'I have read Telecare\'s Privacy Policy and I understand that the information submitted in this form will be accessed by:\n'
      + ' - Telecare\'s practice management and reception team\n'
      + ' - Telecare\'s team of clinicians to ensure I receive optimal care',
  },
};
